import {
  BasicSpacingLayoutAdjusterAbstract,
  SpacingRuleSet,
} from '../../layout_adjusters/BasicSpacingLayoutAdjusterAbstract'
import { MountingSystemAbstract } from '../../MountingSystemAbstract'
import { CompatibilityParameters, Fastener } from '../../types'
import { SolarPortBomGenerator } from './SolarPortBomGenerator'

const spacingRuleSet: SpacingRuleSet = {
  interPanel: { horizontalSpacing: 20, verticalSpacing: 20 },
}

class SolarPortSpacingAdjuster extends BasicSpacingLayoutAdjusterAbstract {
  spacingRuleSet = spacingRuleSet
}

export class SolarPortGroundMount extends MountingSystemAbstract {
  layoutAdjusterClass = SolarPortSpacingAdjuster
  bomGeneratorClass = SolarPortBomGenerator

  getFastener(): Fastener {
    return {
      includedInRoofHookProduct: false,
      name: '',
      qtyPerRoofHook: 0,
      length: 0,
      diameter: 0,
      components: [],
    }
  }

  getCompatibilityParameters(): CompatibilityParameters {
    return {
      integrations: [],
      roofTypeRequired: false,
      panelOrientation: 'portrait',
    }
  }
}
